import { SplitView } from '@approvalmax/ui/src/components';
import { ui } from 'modules/common';
import { memo } from 'react';
import bemFactory from 'react-bem-factory';

import { useDocumentPreview } from './DocumentPreview.hooks';
import { Root } from './DocumentPreview.styles';

const qa = bemFactory.qa('rpt-document-preview-popup');

export const DocumentPreview = memo(() => {
    const { request, currentPage, activeDocument, handleGoToPrevDocument, handleGoToNextDocument, handleClose } =
        useDocumentPreview();

    return (
        <Root direction='column' width='100%' height='100%' data-qa={qa()}>
            <SplitView pinned={false}>
                <SplitView.Item
                    renderByDefault
                    title={activeDocument.name}
                    onClose={handleClose}
                    hideToggleFullscreen
                    showInFullScreen={false}
                    actions={
                        <>
                            <SplitView.Addons.DownloadButton url={activeDocument.url} />

                            <SplitView.Addons.Pagination
                                currentIndex={(currentPage || 0) + 1}
                                total={request.attachments.length}
                                goToNextDocument={handleGoToNextDocument}
                                goToPrevDocument={handleGoToPrevDocument}
                            />
                        </>
                    }
                >
                    <ui.DocumentPreviewPanel
                        document={activeDocument}
                        onRequestClose={close}
                        onRequestBack={handleGoToPrevDocument}
                        onRequestNext={handleGoToNextDocument}
                    />
                </SplitView.Item>
            </SplitView>
        </Root>
    );
});

DocumentPreview.displayName = 'DocumentPreview';
